import { compact, split } from 'lodash';

/**
 * Estimates CSV data row count for subscription import UX: non-empty lines minus one header row.
 * Blank lines (including a trailing newline-only tail) are omitted so the count aligns when the
 * server ignores empty rows.
 *
 * @param {File} file
 * @returns {Promise<number>}
 */
export default async function countCsvDataRows(file) {
  const text = await file.text();
  const lines = compact(split(text, /\r?\n/));
  if (lines.length === 0) {
    return 0;
  }
  return Math.max(0, lines.length - 1);
}
